<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-2" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center py-1 px-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #11998e 0%, #38ef7d 100%);">
            <i class="fa fa-percent text-white"></i>
          </div>
          <div>
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'" style="font-size: 1.15rem;">Tributação do ICMS</h4>
            <small class="text-muted small">Gerenciamento de regras de tributação</small>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 py-1 px-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarHtml()" v-b-tooltip.hover title="Imprimir Listagem">
                        <i class="fa fa-print"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <b-button-group class="mr-2 d-lg-none">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtroAvancado = !filtroAvancado" v-b-tooltip.hover title="Filtros">
                        <i class="fa fa-filter" :class="{'text-primary': filtroAvancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limparFiltro()" v-b-tooltip.hover title="Limpar">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2">
                    <b-form-input type="text" ref="edDescricao" v-model="descricao" placeholder="Buscar por descrição..." class="border-0 bg-transparent" style="width: 200px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="px-4 font-weight-bold shadow-sm text-white btn-filtrar-responsive" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> <span class="d-none d-sm-inline">FILTRAR</span>
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="success" pill class="px-4 font-weight-bold shadow-sm btn-adicionar-responsive" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-1"></i>
              <span class="d-none d-sm-inline">Nova Tributação</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtroAvancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium compact-filter p-3 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="2">
                      <label class="modal-label-premium">ID</label>
                      <b-form-input type="text" v-model="id" placeholder="Ex: 12345" class="rounded-pill shadow-xs" @keydown.enter.native="pesquisar()"></b-form-input>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!--/.row-->
      <b-row class="ml-0 mr-0 p-0" :class="isDark ? 'bg-dark' : 'bg-white'">
        <b-col sm="12" class="px-2">
          <div class="bg-white rounded border shadow-sm overflow-hidden">
            <b-table 
                    ref="tbl"
                    class="mb-0 table-finance"
                    :head-variant="isDark ? 'dark' : 'light'"
                    :dark="isDark"
                    show-empty
                    empty-text="Nenhuma tributação encontrada"
                    responsive 
                    :sticky-header="stickyHeight"
                    hover 
                    small
                    :busy.sync="isBusy" 
                    :items="itensFiltrados" 
                    :fields="colunas"
                    :current-page="currentPage"
                    @row-clicked="clicarLinha"
                    :per-page="perPage"
                    @row-dblclicked="edit"
                    :tbody-tr-class="rowClassSelecionado"    
                    >
                  
              <template #head(ID)>
                <SetFilter label="ID" v-model="filtros.ID" :options="opcoes.ID" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(SITUACAO)>
                <SetFilter label="Situação" v-model="filtros.SITUACAO" :options="opcoes.SITUACAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(DESCRICAO)>
                <SetFilter label="Descrição" v-model="filtros.DESCRICAO" :options="opcoes.DESCRICAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(OP_ICMS_SITUACAO_TRIBUTARIA)>
                <SetFilter label="ICMS ST" v-model="filtros.OP_ICMS_SITUACAO_TRIBUTARIA" :options="opcoes.OP_ICMS_SITUACAO_TRIBUTARIA" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(OP_DESTINO_OPERACAO)>
                <SetFilter label="Destino da Operação" v-model="filtros.OP_DESTINO_OPERACAO" :options="opcoes.OP_DESTINO_OPERACAO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              <template #head(USUARIO_CADASTRO)>
                <SetFilter label="Usuário" v-model="filtros.USUARIO_CADASTRO" :options="opcoes.USUARIO_CADASTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
               <template #head(DATA_CADASTRO)>
                <SetFilter label="Data Cadastro" v-model="filtros.DATA_CADASTRO" :options="opcoes.DATA_CADASTRO" :normalizeFn="normalize" :dropdown-variant="isDark ? 'dark' : 'none'" />
              </template>
              
              <template #empty>
                <div class="h-100 d-flex align-items-center justify-content-center">
                  Nenhum registro encontrado
                </div>
              </template>
              
              <template #cell(actions)="item">
                <div class="d-flex justify-content-center gap-1">
                  <b-button type="button" @click.stop.prevent="edit(item.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                    <i class="fa fa-pencil"></i>
                  </b-button>
                  <b-button type="button" @click.stop.prevent="excluir(item.item)" variant="soft-danger" pill class="btn-icon-only shadow-sm" title="Excluir" v-b-tooltip.hover>
                    <i class="fa fa-trash"></i>
                  </b-button>
                </div>
              </template>

              <template #cell(SITUACAO)="row">
                <b-badge :variant="row.item.SITUACAO  ? 'success' : 'danger'" pill>
                  {{ row.item.SITUACAO ? 'ATIVO' : 'INATIVO' }}
                </b-badge>
              </template>

            </b-table>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import Tools from '@/tools/tools.js'
import SetFilter from '@/components/Cec/SetFilter.vue'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import { mapGetters } from 'vuex'
import { printHtmlReport, exportExcelXlsx, exportCsv } from '@/utils/RelatorioHTML'

export default {
  components: { SetFilter },
  mixins: [createCecTableToolsMixin({ rowsProp: 'lista', tblRef: 'tbl', useExternalPaging: false, filters: [
    { key: 'ID', type: 'number', label: 'ID' },
    { key: 'SITUACAO', type: 'string', label: 'Situação' },
    { key: 'DESCRICAO', type: 'string', label: 'Descrição' },
    { key: 'OP_ICMS_SITUACAO_TRIBUTARIA', type: 'string', label: 'ICMS ST' },
    { key: 'OP_DESTINO_OPERACAO', type: 'string', label: 'Destino Operação' },
    { key: 'USUARIO_CADASTRO', type: 'string', label: 'Usuário' },
    { key: 'DATA_CADASTRO', type: 'date', label: 'Data Cadastro' }
  ] })],

  data() {
    return {
      isBusy: false,
      filtroAvancado: false,
      colunas: [
        { key: 'ID', label: 'ID', sortable: true, class: 'text-right', thStyle: { width: '80px' } },
        { key: 'SITUACAO', label: 'Situação', sortable: true, class: 'text-center', thStyle: { width: '100px' } },
        { key: 'DESCRICAO', label: 'Descrição', sortable: true, thStyle: { width: '30%' }  },
        { key: 'OP_ICMS_SITUACAO_TRIBUTARIA', label: 'ICMS ST', sortable: true, class: 'text-center' },
        { key: 'OP_DESTINO_OPERACAO', label: 'Destino Operação', sortable: true, class: 'text-center' },
        { key: 'USUARIO_CADASTRO', label: 'Usuário', sortable: true },
        { key: 'DATA_CADASTRO', label: 'Cadastro', sortable: true, formatter: val => Tools.formatarDataBR(val) },
        { key: 'actions', label: 'Ações', class: 'text-center', thStyle: { width: '120px' } }
      ]
    }
  },

  computed: {
    isDark() { return this.$store.getters['tema/IS_DARK'] },
    ...mapGetters('tributacaoIcms', ['LISTA','ID','DESCRICAO','REGISTRO_SELECIONADO_ID','RECARREGAR_LISTA']),

    lista: {
      get() { return this.LISTA },
      set(v) { this.$store.commit('tributacaoIcms/SET_LISTA', v) }
    },
    descricao: {
      get() { return this.$store.getters['tributacaoIcms/DESCRICAO'] },
      set(v) { this.$store.commit('tributacaoIcms/SET_DESCRICAO', v) }
    },
    id: {
      get() { return this.$store.getters['tributacaoIcms/ID'] },
      set(v) { this.$store.commit('tributacaoIcms/SET_ID', v) }
    },
    stickyHeight() {
      return 'calc(100vh - 200px)'
    }
  },

  methods: {
    clicarLinha(item) { this.$store.commit('tributacaoIcms/SET_REGISTRO_SELECIONADO_ID', item.ID) },
    rowClassSelecionado(item, type) { 
      if (type !== 'row' || !item) return ''
      const selId = this.$store.getters['tributacaoIcms/REGISTRO_SELECIONADO_ID']
      return item.ID === selId ? 'cec-row-selected' : ''
    },
    
    scrollToSelected() {
      this.$nextTick(() => {
        setTimeout(() => {
          const el = document.querySelector('.cec-row-selected')
          if (el) {
            el.scrollIntoView({ behavior: 'smooth', block: 'center' })
          }
        }, 500)
      })
    },

    limparFiltro() {
      this.$store.commit('tributacaoIcms/SET_LIMPAR', null);
      this.filtroAvancado = false;
      this.pesquisar()
    },

    novo() {
      this.$router.push('/cadastros/tributacao-icms/add')
    },

    edit(item) {
      if (!item || !item.ID) return
      this.$store.commit('tributacaoIcms/SET_REGISTRO_SELECIONADO_ID', item.ID)
      this.$router.push(`/cadastros/tributacao-icms/edit/${item.ID}`)
    },

    async pesquisar() {
      try {
        this.$store.commit('controle/setAguardando', true)
        this.isBusy = true
        
        const response = await this.$http.get('/api/protected/tributacaoIcms/pesquisar', {
          params: { descricao: this.descricao }
        })
        
        let dados = response.data
        if (dados && dados.data) dados = dados.data
        
        this.$store.commit('tributacaoIcms/SET_LISTA', dados)

        // Scroll para o registro selecionado após carregar os dados
        if (this.$store.getters['tributacaoIcms/REGISTRO_SELECIONADO_ID']) {
          this.scrollToSelected()
        }

      } catch (err) {
        console.error('Erro ao pesquisar Tributação ICMS:', err)
        this.$bvToast.toast('Erro ao pesquisar registros', { title: 'Erro', variant: 'danger' })
      } finally {
        this.isBusy = false
        this.$store.commit('controle/setAguardando', false)
      }
    },

    async excluir(item) {
      const confirmed = await this.$bvModal.msgBoxConfirm(`Deseja realmente excluir a tributação "${item.DESCRICAO}"?`, {
        title: 'Confirmar Exclusão',
        okVariant: 'danger',
        okTitle: 'Sim, Excluir',
        cancelTitle: 'Cancelar',
        centered: true
      })

      if (!confirmed) return

      try {
        this.$store.commit('controle/setAguardando', true)
        
        const payload = {
          id: item.ID,
          login: window.localStorage.getItem('login') || 'sistema'
        }

        await this.$http.post('/api/protected/tributacaoIcms/delete', payload)
        
        this.$bvToast.toast('Registro excluído com sucesso', { title: 'Sucesso', variant: 'success' })
        this.pesquisar()

      } catch (err) {
        console.error('Erro ao excluir Tributação ICMS:', err)
        this.$bvToast.toast('Erro ao excluir registro', { title: 'Erro', variant: 'danger' })
      } finally {
        this.$store.commit('controle/setAguardando', false)
      }
    },

    exportarHtml() { printHtmlReport({ rows: this.lista, columns: this.colunas, systemName: 'CECWeb', reportTitle: 'Listagem de Tributação ICMS', printedBy: window.localStorage.getItem('login') ?? '—' }) },
    exportarExcel() { exportExcelXlsx({ rows: this.lista, columns: this.colunas, filename: 'tributacao-icms-lista.xls' }) }
  },

  async created() {
    if (this.RECARREGAR_LISTA || !this.LISTA || this.LISTA.length === 0) {
      this.$store.commit('tributacaoIcms/SET_RECARREGAR_LISTA', false)
      await this.pesquisar()
    } else {
      // Se não precisou recarregar mas tem um registro selecionado, fazer scroll
      if (this.REGISTRO_SELECIONADO_ID) {
        this.$nextTick(() => {
          this.scrollToSelected()
        })
      }
    }
  },
  
  mounted() {
    // Focus no campo de busca
    this.$nextTick(() => {
      if (this.$refs.edDescricao) this.$refs.edDescricao.$el.focus()
    })
  }
}
</script>

<style lang="scss" scoped>
/* Scoped styles if needed */
</style>



// WEBPACK FOOTER //
// src/views/cadastros/tributacao-icms/TributacaoIcmsListagem.vue